import styled from "styled-components";

export const MoreContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const MoreContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const MainContentsSection = styled.section`
  display: flex;
  flex-direction: column;
`;

export const MainProfileSection = styled.section`
  display: flex;
  flex-direction: row;
  gap: 21px;
`;

export const MainProfileBox = styled.div`
  width: 96px;
  height: 96px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.box};
  border-radius: 100%;
  padding: 6px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;

export const ProfileTxtBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const UserAuthSpan = styled.span`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.5rem;
  font-weight: 600;
`;

export const UserStatusBox = styled.div`
  font-size: 2.2rem;
  font-weight: 600;
  line-height: 3.2rem;
  letter-spacing: -0.08rem;
  display: flex;
  flex-direction: row;
  gap: 3px;

  span {
    font-weight: 700;
  }
`;

export const UserNumberBox = styled.div`
  font-size: 1.8rem;
  line-height: 3.2rem;
  letter-spacing: -0.08rem;

  span {
    font-weight: 700;
  }
`;
